// extracted by mini-css-extract-plugin
export default {"IndicatorsCell":"IndicatorsCell_IndicatorsCell__iOS+A"};